import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { Footer, Header, CookieBanner } from '@core/components';
import { SeoService } from '@core/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Footer, Header, CookieBanner],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'EVRN — Control Over Machines',
      description:
        'The directing layer for generative video. Turn any 2D image into a 3D scene you control.',
      siteName: 'EVRN',
      image: '/assets/og-image.png',
      url: 'https://evrn.world/',
      type: 'website',
      locale: 'en_US',
    });
  }
}
